var SignupService = /** @class */ (function () {
    function SignupService(api) {
        var _this = this;
        this.sendUserEmailVerification = function (data, isUser) {
            if (isUser === void 0) { isUser = false; }
            return _this.API.post("/signup/verification/code?verify=".concat(isUser), data);
        };
        this.saveUserMeta = function (user) { return _this.API.post("/signup/user", user); };
        this.saveUserOnly = function (user) { return _this.API.post("/signup/user/only", user); };
        this.saveDevPlan = function (dev_plan, currency) {
            return _this.API.post("/signup/devplan", {
                dev_plan: dev_plan,
                currency: currency,
            });
        };
        this.saveOrg = function (organization) { return _this.API.post("/signup/organization", organization); };
        this.verifyEmail = function (email, code) {
            return _this.API.patch("/signup/verification/code/".concat(code), { email: email });
        };
        this.createSingupForCard = function () { return _this.API.patch("/signup/complete/card"); };
        this.completeSignupFlow = function () { return _this.API.patch("/signup/complete"); };
        this.completeInvoiceSignup = function (country) {
            return _this.API.patch("/signup/complete/invoice", { country: country });
        };
        this.generateSecureURL = function () { return _this.API.post("/signup/generate"); };
        this.validateURL = function () { return _this.API.get("/signup/validate"); };
        this.generateSignupToken = function (campaign) {
            var url = "/signup/generate";
            if (campaign) {
                url = "/signup/generate?campaign=".concat(campaign);
            }
            return _this.API.post(url);
        };
        this.getSignupFlowDevs = function (campaignName, country, interval, currency) {
            var url = "/signup/campaign";
            if (campaignName) {
                url = "".concat(url, "?name=").concat(campaignName);
            }
            if (interval) {
                url = campaignName
                    ? "".concat(url, "&interval=").concat(interval)
                    : "".concat(url, "?interval=").concat(interval);
            }
            if (country) {
                url =
                    interval || campaignName
                        ? "".concat(url, "&country=").concat(country)
                        : "".concat(url, "?country=").concat(country);
            }
            if (currency) {
                url =
                    interval || campaignName || country
                        ? "".concat(url, "&currency=").concat(currency)
                        : "".concat(url, "?currency=").concat(currency);
            }
            return _this.API.get(url);
        };
        this.API = api;
    }
    SignupService.prototype.assignPaymentMethodToSignup = function (paymentMethodId, country) {
        var url = "/signup/payment/assign";
        var body = {
            payment_method_id: paymentMethodId,
            country: country,
        };
        return this.API.post(url, body);
    };
    return SignupService;
}());
export { SignupService };
